import React from 'react';

const Locked = () => <span>Locked</span>;

export default Locked;
